import { EPosition, IFilters, IFiltersMeta, TFilterKeys } from '../../types/filters';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EFiltersActionType {
  StartFetchingMeta = 'BuildersProjectsFilters/StartFetchingMeta',
  SetMeta = 'BuildersProjectsFilters/SetMeta',
  SetSavedFilters = 'BuildersProjectsFilters/SetSavedFilters',
  ReplaceSavedFilters = 'BuildersProjectsFilters/ReplaceSavedFilters',
  MergeFilters = 'BuildersProjectsFilters/MergeFilters',
  SetOpenedFilter = 'BuildersProjectsFilters/SetOpenedFilter',
  SetTooltipTarget = 'BuildersProjectsFilters/SetTooltipTarget',
  SetFiltersPosition = 'BuildersProjectsFilters/SetFiltersPosition',
}

export type TBuildersProjectsFiltersActions =
  | TSetMeta
  | TStartFetchingMeta
  | TSetSavedFilters
  | TMergeFilters
  | TSetOpenedFilter
  | TSetTooltipTarget
  | TSetFiltersPosition
  | TReplaceSavedFilters;

export type TSetFiltersPosition = ITypedReduxAction<EFiltersActionType.SetFiltersPosition, EPosition>;

export type TStartFetchingMeta = ITypedReduxAction<EFiltersActionType.StartFetchingMeta>;

export type TSetMeta = ITypedReduxAction<EFiltersActionType.SetMeta, IFiltersMeta>;

export type TSetSavedFilters = ITypedReduxAction<EFiltersActionType.SetSavedFilters, Partial<IFilters>>;

export type TReplaceSavedFilters = ITypedReduxAction<EFiltersActionType.ReplaceSavedFilters, IFilters>;

export type TMergeFilters = ITypedReduxAction<EFiltersActionType.MergeFilters>;

export type TSetOpenedFilter = ITypedReduxAction<EFiltersActionType.SetOpenedFilter, TFilterKeys | undefined>;

export type TSetTooltipTarget = ITypedReduxAction<EFiltersActionType.SetTooltipTarget, TFilterKeys | undefined>;
